import Typography from '@/ui/components/typography'
import { StyledIntegrationStatus } from './IntegrationStatus.styles'
import ExclamationIcon from '@assets/images/exclamation-icon.svg?react'
import {
    TAllIntegrations,
    TIntegrationStatus,
} from '@/core/modules/integrations/integrations'
import { theme } from '@/core/theme/theme-light'
import { CustomTooltip } from '@atbay/component-lib'
import { TooltipContent } from '../IntegrationsTable.styles'

export type IntegrationStatusProps = {
    status: TIntegrationStatus
    type: TAllIntegrations
}

const PROVIDER_NAMES: Record<TAllIntegrations, string> = {
    google: 'Google',
    google_fraud_defense: 'Google',
    microsoft: 'Microsoft',
    ms_fraud_defense: 'Microsoft',
    crowdstrike: 'Crowdstrike',
}

const STATUS_TEXT: Record<TIntegrationStatus, string> = {
    active: 'Active',
    broken: 'Error',
    inactive: 'Inactive',
}

const IntegrationStatus = ({ status, type }: IntegrationStatusProps) => {
    const statusText = STATUS_TEXT[status]
    const providerName = PROVIDER_NAMES[type]

    return (
        <CustomTooltip
            title={
                <TooltipContent>
                    <Typography
                        variant="xs-semibold"
                        color={theme.colors.semantic.dark}
                    >
                        {`This ${providerName} account is disconnected.`}
                    </Typography>
                    <Typography
                        variant="xs-regular"
                        color={theme.colors.semantic.dark}
                    >
                        Reconnect to restore full protection and visibility.
                    </Typography>
                </TooltipContent>
            }
            tooltipStyles={{
                padding: '12px 16px',
                backgroundColor: theme.colors.greys[0],
                color: theme.colors.greys[800],
                boxShadow: '1px 1px 20px 2px rgba(0, 0, 0, 0.1)',
            }}
            arrowStyles={{
                color: theme.colors.greys[0],
                filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.2))',
            }}
            placement="top"
            alwaysShowOnHover={status === 'broken'}
        >
            <StyledIntegrationStatus status={status}>
                {status === 'broken' && (
                    <ExclamationIcon width={12} height={12} />
                )}
                <Typography variant="s-regular">{statusText}</Typography>
            </StyledIntegrationStatus>
        </CustomTooltip>
    )
}

export default IntegrationStatus
